import React from "react";
import { NavLink } from "react-router-dom";

const Navbar = props => {
  return (
    <div className="nav">
      <div className="nav1a">
        <NavLink to={"/pandora-commerce"}>Home</NavLink>
      </div>
      <div className="nav1b">
        <div className="nav1c">
          {!props.login ? (
            <NavLink to={"/pandora-commerce/signup"}>Sign Up</NavLink>
          ) : null}
        </div>
        <div className="nav1d">
          <NavLink to={"/pandora-commerce/login"}>Members</NavLink>
          <div className="membersDropdown">
            <p>
              {!props.login ? (
                <NavLink to={"/pandora-commerce/login"}>Login</NavLink>
              ) : null}
            </p>
            <p>
              {props.login ? (
                <NavLink to={"/pandora-commerce/member"}>Account</NavLink>
              ) : null}
            </p>
            {props.login ? <p onClick={() => props.logout()}>Logout</p> : null}
          </div>
        </div>
        <div className="nav1e">
          <NavLink to={"/pandora-commerce/basket"}>Basket</NavLink>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
